import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import LoginPage from '../pages/LoginPage';
import AdminLayout from '../layouts/AdminLayout';
import TutorLayout from '../layouts/TutorLayout';
import ParentLayout from '../layouts/ParentLayout';
import AdminHome from '../pages/admin/AdminHome';
import TutorsPage from '../pages/admin/TutorsPage';
import ParentsPage from '../pages/admin/ParentsPage';
import StudentsPage from '../pages/admin/StudentsPage';
import AdminStudentJournalPage from '../pages/admin/AdminStudentJournalPage';
import AdminSchedulePage from '../pages/admin/AdminSchedulePage';
import AdminTutorProfilePage from '../pages/admin/AdminTutorProfilePage';
import AdminReportsPage from '../pages/admin/AdminReportsPage';
import AdminStudentReportsPage from '../pages/admin/AdminStudentReportsPage';
import AdminAccountingPage from '../pages/admin/AdminAccountingPage';
import TutorHomePage from '../pages/tutor/TutorHomePage';
import TutorStudentsPage from '../pages/tutor/TutorStudentsPage';
import StudentJournalPage from '../pages/tutor/StudentJournalPage';
import TutorSchedulePage from '../pages/tutor/TutorSchedulePage';
import TutorProfilePage from '../pages/tutor/TutorProfilePage';
import TutorSettingsPage from '../pages/tutor/TutorSettingsPage';
import GoogleCallbackPage from '../pages/tutor/GoogleCallbackPage';
import ParentStudentsPage from '../pages/parent/ParentStudentsPage';
import ParentJournalPage from '../pages/parent/ParentJournalPage';
import ParentSettingsPage from '../pages/parent/ParentSettingsPage';
import ParentTutorProfilePage from '../pages/parent/ParentTutorProfilePage';
import ParentTutorsPage from '../pages/parent/ParentTutorsPage';
import { ROLES } from '../utils/roles';

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />

    <Route element={<ProtectedRoute roles={[ROLES.ADMIN]} />}>
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminHome />} />
        <Route path="tutors" element={<TutorsPage />} />
        <Route path="parents" element={<ParentsPage />} />
        <Route path="students" element={<StudentsPage />} />
        <Route path="students/:studentId" element={<AdminStudentJournalPage />} />
        <Route path="schedule" element={<AdminSchedulePage />} />
        <Route path="tutors/:tutorId/profile" element={<AdminTutorProfilePage />} />
        <Route path="accounting" element={<AdminAccountingPage />} />
        <Route path="reports" element={<AdminReportsPage />} />
        <Route path="reports-students" element={<AdminStudentReportsPage />} />
      </Route>
    </Route>

    <Route element={<ProtectedRoute roles={[ROLES.TUTOR]} />}>
      <Route path="/tutor" element={<TutorLayout />}>
        <Route index element={<TutorHomePage />} />
        <Route path="students" element={<TutorStudentsPage />} />
        <Route path="students/:studentId" element={<StudentJournalPage />} />
        <Route path="schedule" element={<TutorSchedulePage />} />
        <Route path="profile" element={<TutorProfilePage />} />
        <Route path="settings" element={<TutorSettingsPage />} />
        <Route path="settings/google-callback" element={<GoogleCallbackPage />} />
      </Route>
    </Route>

    <Route element={<ProtectedRoute roles={[ROLES.PARENT]} />}>
      <Route path="/parent" element={<ParentLayout />}>
        <Route index element={<ParentStudentsPage />} />
        <Route path="journal/:studentId" element={<ParentJournalPage />} />
        <Route path="tutors" element={<ParentTutorsPage />} />
        <Route path="tutor/:tutorId" element={<ParentTutorProfilePage />} />
        <Route path="settings" element={<ParentSettingsPage />} />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default AppRoutes;

